import LinkToDocusaurus from '../LinkToDocusaurus'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import type { CSSProperties } from 'react'

const infoContentStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  rowGap: '16px'
}

const TestConfigParameterDefaultValueInfo = () =>
  <div style={infoContentStyle}>
    <Paragraph>
      <Color variant='theme-description-text'>
        The default parameter value is taken from the test case. If there are no parameter values set in test case, it will use the initial value from the model, which is always auto-generated by DAI.
      </Color>
    </Paragraph>
    <Paragraph>
      <LinkToDocusaurus path='dai-test-configuration'>
        Learn more in the DAI documentation
      </LinkToDocusaurus>
    </Paragraph>
  </div>

export default TestConfigParameterDefaultValueInfo
